<template>
  <div>
    
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/adminTools"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-11">
          <h4><u>user Log entries</u></h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        Ημερομηνία
        <DxDateBox :value="date" picker-type="calendar" display-format="dd/MM/yyyy" @value-changed="setSelectedDate"
          :allow-editing="false" />
      </div>
      <div class="col-md-3">
        <DxLoadIndicator id="image-indicator" :height="40" :width="40" :visible="loadIndicatorVisible" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 grid-pad">
        <DxDataGrid :data-source="logs" :allow-column-reordering="true" :allow-column-resizing="true"
          :column-auto-width="true" :show-borders="true" :show-row-lines="true" :row-alternation-enabled="true"
          width="100%">
          <DxPaging :page-size="20" :enabled="true" />
          <DxEditing :allow-updating="true" :use-icons="true" mode="cell" />
          <DxHeaderFilter :visible="true" />
          <DxFilterRow :visible="true" />
          <DxSearchPanel :visible="true" />
          <DxExport :enabled="true" :allow-export-selected-data="true" />

          <DxSelection mode="multiple" />
          <!--  <DxColumn  caption="Κωδικός" data-field="Id" data-type="integer" :visible="false">                    
                </DxColumn> -->
          <DxColumn caption="Ώρα Εισόδου" :allow-editing="false" data-field="LoginDate" data-type="date" :visible="true"
            width="200px" alignment="center" format="dd/MM/yyyy hh:mm:ss" :allow-filtering="false">
          </DxColumn>
          <DxColumn caption="Ονοματ.Χρήστη" :allow-editing="false" data-field="UserName" data-type="string"
            :visible="true" width="300px" alignment="left" :allow-filtering="true">
          </DxColumn>
          <DxColumn caption="Ip Address" :allow-editing="false" data-field="IpAddress" data-type="string"
            :visible="true" width="250px" alignment="left" :allow-filtering="true">
          </DxColumn>
          <DxColumn caption="Τύπος Εισόδου" :allow-editing="false" data-field="LoginType" data-type="string"
            :visible="true" width="200px" alignment="left" :allow-filtering="true">
          </DxColumn>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import BackButton from "../../components/shared/backButton";
import mainService from "../../services/mainService";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxPaging,
  DxFilterRow,
  DxSearchPanel,
  DxEditing,
  DxExport,
  DxSelection,
} from "devextreme-vue/data-grid";
import DxDateBox from "devextreme-vue/date-box";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";

export default {
  components: {
    BackButton,
    DxLoadIndicator,
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxPaging,
    DxFilterRow,
    DxSearchPanel,
    DxEditing,
    DxDateBox,
    DxExport,
    DxSelection,
  },
  data() {
    return {
      date: this.$moment().format("MM/DD/YYYY"),
      loadIndicatorVisible: false,
      logs: [],
    };
  },
  created() {},
  computed: {
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
  },
  methods: {
    async setSelectedDate(e) {
      this.logs = [];
      this.loadIndicatorVisible = true;
      if (e.value != null) {
        const res = await mainService.get(
          `/LoginLogs/GetLoginLogsByDate?date=${e.value}`
        );
        this.logs = res.data;
      }
      this.loadIndicatorVisible = false;
    },
  },
  async mounted() {
    this.loadIndicatorVisible = true;
    const res = await mainService.get(
      `/LoginLogs/GetLoginLogsByDate?date=${this.date}`
    );
    this.logs = res.data;
    this.loadIndicatorVisible = false;
  },
};
</script>

<style scoped>
</style>
